<!-- Centered branding, end-of-session message and animated diagram -->
<div class="flex flex-1 min-h-0 flex-col items-center justify-center gap-16 px-6">
  <!-- Medinbox AI branding (logo + AI icon) -->
  <div class="flex items-center gap-4">
    <mai-mib-logo size="large"></mai-mib-logo>
  </div>

  <!-- End-of-session message, announced to assistive technologies -->
  <div class="flex flex-col items-center gap-2 text-center text-[#102753]" role="status" aria-live="polite">
    <h1 class="text-[33px] font-normal leading-normal">Session terminated</h1>
    <p class="text-base font-normal leading-6">
      Find out more on
      <a
        class="underline"
        href="https://www.medinbox.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        www.medinbox.com
      </a>
    </p>
  </div>

  <!-- Decorative animated illustration (self-drawing SVG) -->
  <img
    class="block w-full max-w-[617px] aspect-[617/404]"
    src="./svg/medinbox-diagram-animated.svg"
    alt=""
    aria-hidden="true"
  />
</div>

<!-- Footer -->
<footer class="flex w-full items-center justify-center py-8">
  <mai-copyright-and-legal-link
    class="text-center font-light text-gray-500"
  ></mai-copyright-and-legal-link>
</footer>
